import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1031"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M1.983 8.635 5.408 6.47a.287.287 0 0 0-.068-.516l-1.849-.578a5.18 5.18 0 0 1 .806-1.079 5.244 5.244 0 0 1 1.665-1.123 5.288 5.288 0 0 1 4.077 0 5.211 5.211 0 0 1 1.665 1.123 5.233 5.233 0 0 1 1.123 1.665.7.7 0 0 0 1.289-.545 6.6 6.6 0 0 0-1.422-2.11 6.623 6.623 0 0 0-2.11-1.422 6.688 6.688 0 0 0-5.168 0 6.606 6.606 0 0 0-2.11 1.422c-.484.484-.859 1.046-1.17 1.645L.4 4.409a.287.287 0 0 0-.351.382l1.515 3.71a.288.288 0 0 0 .419.134zm13.995 2.398-1.515-3.71a.286.286 0 0 0-.418-.134L10.62 9.354a.287.287 0 0 0 .068.516l1.907.597a5.228 5.228 0 0 1-.891 1.238 5.211 5.211 0 0 1-1.665 1.123 5.288 5.288 0 0 1-4.077 0 5.233 5.233 0 0 1-1.665-1.123 5.232 5.232 0 0 1-1.123-1.666.7.7 0 0 0-1.289.545c.333.79.812 1.5 1.422 2.11A6.617 6.617 0 0 0 8 14.638a6.603 6.603 0 0 0 4.693-1.944 6.617 6.617 0 0 0 1.256-1.804l1.678.525a.287.287 0 0 0 .351-.382z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }